export default __webpack_public_path__ + "images/HU.f87eae7.png";